import type { SVGProps } from 'react';
const DawnFlagZA = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#06A86E" rx={2} />
    <mask
      id="dawn-flag-ZA_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-ZA_svg__a)">
      <path fill="#FFBF2E" d="M0 2.133 7.333 8 0 13.867z" />
      <path fill="#262626" d="M-1.048 2.4 6.024 8l-7.072 5.6z" />
      <path fill="#fff" d="M9.429 6.4 2.096 0H22v6.4z" />
      <path fill="#F44E46" d="M9.69 5.333 3.404 0H22v5.333z" />
      <path fill="#fff" d="M2.096 16H22V9.6H9.429z" />
      <path fill="#072CB4" d="M3.404 16H22v-5.333H9.69z" />
    </g>
  </svg>
);
export default DawnFlagZA;
